import React, { useRef, useState } from 'react'

export default function CardAnimation({ card }) {
  const [rotateX, setRotateX] = useState('0')
  const [rotateY, setRotateY] = useState('0')
  const [cardScale, setCardScale] = useState('1')

  const cardRotatorRef = useRef()

  const onMouseMove = (e) => {
    e.preventDefault()
    setRotateY(
      e.nativeEvent.offsetX * (-2 / (cardRotatorRef.current.clientWidth / 10)) + 10 + 'deg'
    )
    setRotateX(
      e.nativeEvent.offsetY * (2 / (cardRotatorRef.current.clientHeight / 10)) - 10 + 'deg'
    )
    setCardScale(1.1)
  }

  const onMouseOut = () => {
    setRotateX(0)
    setRotateY(0)
    setCardScale(1)
  }

  return (
    <>
      <div className='relative select-none card  z-[80]'>
        <div
          className='card__translater '
          style={{
            transform: `scale(${cardScale}) `,
          }}
        >
          <div
            ref={cardRotatorRef}
            className='transition-all duration-700 delay-300 hover:transition-none card__rotator rounded-[15px] card_emphasize_shadow hover:card_hover_shadow border border-sk-border overflow-hidden max-h-[800px]'
            style={{ transform: `rotateX(${rotateX}) rotateY(${rotateY})` }}
            onPointerMove={onMouseMove}
            onMouseMove={(e) => e.preventDefault()}
            onPointerOut={onMouseOut}
            onMouseOut={(e) => e.preventDefault()}
            onDragOver={onMouseMove}
            onDragLeave={onMouseOut}
          >
            <div>
              <img src={card.img} alt={card.portfolio} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
